var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.bol
      ? _c(
          "div",
          {
            staticClass: "LeonDialog",
            on: {
              mousewheel: function($event) {
                $event.preventDefault()
                return null.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "clickoutside",
                    rawName: "v-clickoutside",
                    value: _vm.isShow,
                    expression: "isShow"
                  }
                ],
                staticClass: "LeonDialog_body"
              },
              [_vm._t("default")],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-aeabdc60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-aeabdc60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/LeonDialog/src/main.vue
// module id = null
// module chunks = 